import { MovieOpenOffIcon } from './MovieOpenOffIcon';

/**
 * author: Colton Wiscombe
 * id A58F23CF-24CA-42B3-B877-FA9DEA317A3B
 * name movie-open-off
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-off.svg
 * tags
 * - Video / Movie 
 */
export const FilmOpenOffIcon = MovieOpenOffIcon;
export default FilmOpenOffIcon